export default __webpack_public_path__ + "KaTeX_Math-BoldItalic.d5d35e84b3ac1dbffd8fdc3dbea97849.woff2";